<template>
  <div>
    <div class="">
      <PageHeaderUI
        title="My Transactions"
        breadcrumb="Billings & Payments > My Transactions"
      />
    </div>
    <section class="bg-white my-4 p-3">
      <div class="flex py-4 justify-between">
        <div class="unit-point">
          <p class="w-full">
            Transaction Count: {{ transactionData.pagination && transactionData.pagination.totalCount ? transactionData.pagination.totalCount : 0 }}
          </p>

          <span class="w-12"
            ><img src="@/assets/images/billing/total_value.svg"
          /></span>
        </div>
        <div class="unit-point">
          <p class="w-full">
            Total Value: ₦
            {{ amountFomatter(transactionData.data && transactionData.data.totalAmount ? transactionData.data.totalAmount :  0) }}
          </p>

          <span class="w-12"
            ><img src="@/assets/images/billing/total_value.svg"
          /></span>
        </div>
      </div>

      <TableFilter @setSearchTerm = "sortSearchString" @filterProps="filterProps" @setQueryparams="sortItemProps" :transactions="transactions" />
      <div class="bg-white shadow py-0 mt-8" v-loading="isLoading">
        <transaction-table
          :withAction="true"
          :transactions="transactions"
        />
      </div>

      <PaginationControl
        :total="transactionData.pagination && transactionData.pagination.totalCount ? transactionData.pagination.totalCount : 0"
        :pageNumber="pageNumber"
        @pageNumber="setPageDisplay"
        @pageSize="setNumDisplay"
      />
    </section>
  </div>
</template>

<script>
import TransactionTable from "@/components/Ondemand/Payments/TransactionTable";
import PageHeaderUI from "@/components/Ondemand/UI/PageHeaderUI.vue";
import TableFilter from "@/components/Ondemand/Bookings/module/TableFilter.vue";
import PaginationControl from "@/components/UI/pagination";

export default {
  components: {
    TransactionTable,
    PageHeaderUI,
    TableFilter,
    PaginationControl,
  },
  data() {
    return {
      transactionCount: null,
      isLoading: false,
      transactionData: {},
      transactions: [],

      pageSize: 10,
      pageNumber: 1,
      sortOptions: {
        pageSize: 10,
        pageNumber: 1,
        interval: "month",
        startDate: "2024-09-27",
        endDate: "2024-09-27",
        searchString: "",
      },
    };
  },
  watch: {
    payload() {
      this.getAllTransaction();
    },
  },
  computed: {
    
    payload() {
      return {
        pageSize: this.pageSize,
        interval: this.sortOptions.interval,
        pageNumber: this.pageNumber,
        startDate: this.sortOptions.startDate,
        endDate: this.sortOptions.endDate,
        searchQuery : "",
      };
    },
  },
  mounted() {
    this.getAllTransaction();
  },
  methods: {
      sortSearchString(val) {  
      if (val.length === 6 ) {
        this.payload.searchQuery = val  
        this.getAllTransaction(); 
      } else if (!val.length) {
        this.payload.searchQuery  = ""  
        this.getAllTransaction(); 
      }
    },
    filterProps(val) {
      this.sortOptions.interval = val
      this.getAllTransaction();       
    },

    sortItemProps(val) {
      this.payload.interval = val.interval
      this.payload.startDate = val.startDate
      this.payload.endDate = val.endDate
      this.getAllTransaction(); 
    },
    setPageDisplay(val) {
      this.pageNumber = val;
    },
    setNumDisplay(val) {
      this.pageSize = val;
    },
    async getAllTransaction() {
      this.isLoading = true;
      try {
        const response = await this.$_getAllTransaction(this.payload);
        this.transactionData = response.data;
        this.transactions = response.data.data.transactions ;
        
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.unit-point {
  @apply flex items-center shadow-lg px-4 py-2 rounded-lg;
  width: 48%;
}
</style>
